import React, { useState, useEffect } from 'react'
import { func, bool, number, shape } from 'prop-types'
import { createComponent } from 'react-fela'
import Icon from 'design-framework/common/ui/Icon'
import WhiteCross from 'design-framework/common/icons/close-cross-white.svg'
import {
	__mainWrapper,
	__drawerWrapper,
	__handleWrapper,
	__contentWrapper,
	__iconWrapper,
} from './__style'

const MainWrapper = createComponent(__mainWrapper, 'div', ['onClick'])
const Drawer = createComponent(__drawerWrapper)
const HandleWrapper = createComponent(__handleWrapper, 'hr')
const ContentWrapper = createComponent(__contentWrapper)
const CrossIconWrapper = createComponent(__iconWrapper, 'div', ['onClick'])

const BottomDrawer = ({
	isOpen,
	children,
	toggleHandler,
	minHeight,
	styles,
	showCloseIcon,
}) => {
	const [state, setState] = useState(isOpen)

	useEffect(() => {
		setState(isOpen)
	}, [isOpen])

	const handleClick = ({ target }) => {
		if (target.id === 'drawer-wrapper' || showCloseIcon) {
			setState(false)
			toggleHandler()
		}
	}

	return (
		<MainWrapper
			isOpen={state}
			onClick={e => {
				if (!showCloseIcon) {
					handleClick(e)
				}
			}}
			id="drawer-wrapper"
		>
			<Drawer style={styles} minHeight={minHeight}>
				{showCloseIcon ? (
					<CrossIconWrapper onClick={handleClick}>
						<Icon glyph={WhiteCross} width={18} height={18} />
					</CrossIconWrapper>
				) : null}
				<HandleWrapper />
				<ContentWrapper>{children}</ContentWrapper>
			</Drawer>
		</MainWrapper>
	)
}

BottomDrawer.propTypes = {
	isOpen: bool,
	toggleHandler: func,
	minHeight: number,
	styles: shape({}),
	showCloseIcon: bool,
}

BottomDrawer.defaultProps = {
	isOpen: false,
	toggleHandler: () => {},
	minHeight: 450,
	styles: {},
	showCloseIcon: false,
}

export default BottomDrawer
